import React, {useState, useEffect} from 'react';
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";   
import { useTranslation } from "react-i18next"
import { ENDPOINT} from "constants/variables";
import Box from '@mui/material/Box'; 
import IconButton from '@mui/material/IconButton';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';
import Paper from '@mui/material/Paper';
import PanToolAltIcon from '@mui/icons-material/PanToolAlt'; 
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import TableSortLabel from '@mui/material/TableSortLabel';
import TextField from '@mui/material/TextField';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography'; 
import TableFooter from '@mui/material/TableFooter';
import useTheme from '@mui/material/styles/useTheme';
import visuallyHidden from '@mui/utils/visuallyHidden'; 
import "css/customDialog.css";
import { warningErrorAction } from "actions/ErrorActions"; 
import { helpHttp } from "service/HelpHttp";
import PropTypes from 'prop-types';

const headCellsFormDI = [
  { id: 'ownformdi_id', numeric: false, disablePadding: false, label: 'Text_Code', canOrder: true },
  { id: 'preiddoc_sheet', numeric: false, disablePadding: false, label: 'Text_FORM_PREIDDOC_SHEET', canOrder: true },
  { id: 'sufiddoc_sheet', numeric: false, disablePadding: false, label: 'Text_FORM_SUFIDDOC_SHEET', canOrder: true },
  { id: 'number_dt', numeric: false, disablePadding: false, label: 'Text_FORM_NT_SHEET', canOrder: true },
  { id: 'date_sheet', numeric: false, disablePadding: false, label: 'Text_FORM_DATE', canOrder: true },
  { id: 'rel_trans_tradename', numeric: false, disablePadding: false, label: 'Text_FORM_REL_TRANS', canOrder: true },
  { id: 'rel_trans_licenseplate', numeric: false, disablePadding: false, label: 'Text_FORM_LICENSEPLATE', canOrder: true }
];

EnhancedTableHead.propTypes = {
  onRequestSort: PropTypes.func.isRequired,
  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
  orderBy: PropTypes.string.isRequired,
};

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}
  
function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}
  
function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) {
          return order;
        }
        return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
}

function EnhancedTableHead(props) {
  const { order, orderBy, onRequestSort, t } = props;
  const createSortHandler = (property) => (event) => { onRequestSort(event, property); };
  return (
    <TableHead>
      <TableRow>
        <TableCell
          key='edit'
          align='center'
          padding='normal'
          sortDirection={false}
        >
          <Typography style={{color:"#4e73df", fontSize: 16}} >
            {t('Button_Select')}
          </Typography>
        </TableCell>
        {headCellsFormDI.map((headCell, indexhead) => (
          <TableCell
            key={indexhead}
            align={headCell.numeric ? 'right' : 'left'}
            padding={headCell.disablePadding ? 'none' : 'normal'}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            {headCell.canOrder ?(
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={createSortHandler(headCell.id)}
            >
              <Typography style={{color:"#4e73df", fontSize: 16}} >  
                {t(headCell.label)}
                {orderBy === headCell.id ? (
                  <Box component="span" sx={visuallyHidden}>
                    {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                  </Box>
                ) : null}
              </Typography>
            </TableSortLabel>):
              <Typography style={{color:"#4e73df", fontSize: 16}} >  
                {t(headCell.label)}
              </Typography>}
          </TableCell>
        ))} 
         
      </TableRow>
    </TableHead>
  );
}

const EnhancedTableToolbar = (props) => {
  const { textHead, textReg, numTotRegFilter,numTotRegFormDI, textOf  } = props;
    return (
      <Toolbar>
        <Typography style={{flex: '1 1 100%',color:"#4e73df", fontSize: 28}} id="tableTitle" component="div">
          {textHead}
        </Typography>
        <Typography style={{flexShrink: 0, ml: 2.5, color:"#4e73df", fontSize: 18}} id="tableTitle" component="div">
          {textReg} {(numTotRegFilter).toLocaleString('de-DE')} {textOf} {(numTotRegFormDI).toLocaleString('de-DE')}
        </Typography>
    </Toolbar>
    );
};

function TablePaginationActions(props) {
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;
  const {t} = useTranslation(['listDataShipping']);

  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label={t('Text_First_Page')}
      >
        {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label={t('Text_Previous_Page')}
      >
        {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label={t('Text_Next_Page')}
      >
        {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label={t('Text_Last_Page')}
      >
        {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </Box>
  );
}

TablePaginationActions.propTypes = {
  count: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
};

const TableSortingShippingFormDI =(props)=>{
  const { 
    dataFormDI, 
    numTotRegFilter,
    titleTable,
    numTotRegFormDI,
    activeOffsetFormDI,
    rangeOffsetFormDI,
    currencyOffsetFormDI,
    setCurrencyOffsetFormDI,
    handleCloseDataEditFormDI,
    setFormShipping,
    setOpenChangeTypeOfPrice,
    menuPermissions,
    formShipping
  } = props;
  const {t,i18n} = useTranslation(['listDataShipping']);
  const token = useSelector((state) => state.loginUser.token);   
  const [order, setOrder] = useState('asc');
  const [orderBy, setOrderBy] = React.useState('calories');
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [emptyRows, setEmptyRows] = useState(page > 0 ? Math.max(0, (1 + page) * rowsPerPage - dataFormDI.length) : 0);
  const [countData,setCountData] = useState(dataFormDI.length);
  const dispatch = useDispatch();

  useEffect(
    () => {
      if (dataFormDI.length!==countData || dataFormDI.length<=rowsPerPage){
        setPage(0);
      }  
      setCountData(dataFormDI.length);
      setEmptyRows(page > 0 ? Math.max(0, (1 + page) * rowsPerPage - dataFormDI.length) : 0);  
    },
    [dataFormDI,page,setEmptyRows,rowsPerPage,countData]
  );

  const handleChangeOffset = (event) => {
    setCurrencyOffsetFormDI(event.target.value);
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const selectFormDI = (row) => {
    let isMounted = true;
    setFormShipping(prev => ({
      ...prev,
      formdi_id: row?.id ?? 0,
      ownformdi_id: `${row?.preiddoc_sheet ?? ""}${row?.sufiddoc_sheet ?? ""}`,
      rel_trans_store_id: row?.rel_trans_store_id ?? 0,
      rel_trans_documentid: row?.rel_trans_documentid ?? "",
      rel_trans_tradename: row?.rel_trans_tradename ?? "",
      rel_trans_street: row?.rel_trans_street ?? "",
      vehiclestore_licenseplate: row?.vehiclestore_licenseplate ?? "",
      opt_tras_store_id: row?.opt_tras_store_id ?? 0,
      opt_tras_documentid: row?.opt_tras_documentid ?? "",
      opt_tras_tradename: row?.opt_tras_tradename ?? "",
      opt_tras_street: row?.opt_tras_street ?? "",
      dest_tras_store_id: row?.dest_tras_store_id ?? 0,
      dest_tras_documentid: row?.dest_tras_documentid ?? "",
      dest_tras_tradename: row?.dest_tras_tradename ?? "",
      dest_tras_street: row?.dest_tras_street ?? "",
      typeofprice_id: row?.dest_tras_typeofprice_id ?? 1,
      paymenttype_id: row?.dest_tras_paymenttype_id ?? 1
    }));
    if ( row && row?.codeler_id && row.codeler_id !== "" && row.codeler_id !== "0" && row.codeler_id !== 0) {
      const fetchData = async () => {
        try {
          const getData = await helpHttp().get2(ENDPOINT,`shipping/getarticlebycodelerid/`,token,row.codeler_id);
          if (getData.err) {
            dispatch(warningErrorAction(t("Text_InvalidCredentials")));
            return;
          }
          if (!isMounted) return;
          const selectedTypeOfPrice = getData.articlestoretypesofprices?.find(item =>Number(item.typesofprice_id) ===Number(row?.dest_tras_typeofprice_id ?? 1));
          let estimatedPrice = Number(selectedTypeOfPrice?.saleprice ?? 0);
          if (row?.dest_tras_store_id && row.dest_tras_store_id !== "" && row.dest_tras_store_id !== "0" && row.dest_tras_store_id !== 0) {
            const lastPrice = await helpHttp().get8(ENDPOINT, `shipping/getlastpricearticledesttrasstoreid`,token,getData.article_id,row.dest_tras_store_id);
            if (!lastPrice?.err && Number(lastPrice) > 0) {
              estimatedPrice = Number(lastPrice);
            }
          }
          setFormShipping(prev => {
            const existingIndex = prev.linesshipping.findIndex(
              item => Number(item.article_id) === Number(getData.article_id)
            );
            let updatedLines;
            if (existingIndex !== -1) {
              updatedLines = [...prev.linesshipping];
            } else {
              const amount = Number(row?.delivery_quantity ?? 1);
              const articleToAdd = {
                id: "",
                indexrowarticle:prev.linesshipping.length > 0? prev.linesshipping[prev.linesshipping.length - 1].indexrowarticle + 1: 1,
                shipping_id: prev.id,
                substore_id: prev.substore_id,
                substore_name: prev.substore_name,
                article_id: getData.article_id,
                article_owncode: getData.article_owncode,
                article_codean: getData.article_codean,
                article_barcode: getData.article_barcode,
                article_codeler: getData.article_codeler,
                article_namees: getData.article_namees,
                article_nameen: getData.article_nameen,
                datepurchase: prev.datepurchase,
                amount: amount,
                estimatedprice: estimatedPrice,
                discount: 0,
                tax: getData.article_tax,
                taxincluded: getData.article_taxincluded,
                total:amount *estimatedPrice *(getData.article_taxincluded? 1: 1 + Number(getData.article_tax || 0) / 100),
                articlestoretypesofprices: getData.articlestoretypesofprices
              };
              updatedLines = [...prev.linesshipping, articleToAdd];
            }
            const totalNeto = updatedLines.reduce(
              (acc, item) => acc + Number(item.total || 0),
              0
            );
            return {
              ...prev,
              linesshipping: updatedLines,
              totalnetoshipping: totalNeto + Number(prev.totalnetoservice || 0)
            };
          });
          if (
            menuPermissions.canViewPrice &&
            Number(formShipping.typeofprice_id) !==
              Number(row?.dest_tras_typeofprice_id ?? 1)
          ) {
            setOpenChangeTypeOfPrice(true);
          }
        } catch (error) {
          dispatch(warningErrorAction(t("Text_IncorrectData")));
        }
      };
      fetchData();
    } else {
      dispatch(warningErrorAction(t("Text_IncorrectData")));
    }
    handleCloseDataEditFormDI();
    return () => {
      isMounted = false;
    };
  };
 
  const listItems= (
  stableSort(dataFormDI, getComparator(order, orderBy)).slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, keyData) => {
    return (
      <TableRow hover tabIndex={-1} key={keyData}>
         {(row.id!=="" && row.id!==null ) &&
          <TableCell align="center">
            <IconButton  size="large"  className="edit-select-button" onClick={()=>selectFormDI(row)}>
              <PanToolAltIcon style={{fontSize: 28}}/>
            </IconButton>  
          </TableCell>
        }
        <TableCell align="left">
          <Typography style={{color:"#4e73df", fontSize: 16}} >
            {row.ownformdi_id}
          </Typography>  
        </TableCell> 
        <TableCell align="left">
          <Typography style={{color:"#000000", fontSize: 16}} >
            {row.preiddoc_sheet}
          </Typography>
        </TableCell>
        <TableCell align="left">
          <Typography style={{color:"#000000", fontSize: 16}} >
            {row.sufiddoc_sheet}
          </Typography>
        </TableCell>
        <TableCell align="left">
          <Typography style={{color:"#000000", fontSize: 16}} >
            {row.number_dt}
          </Typography>
        </TableCell>
        <TableCell align="right">
          <Typography style={{color:"#000000", fontSize: 16}} >
            {row.date_sheet!==""?new Date(row.date_sheet).toLocaleDateString(i18n.language==="es"?'es-ES':'en-US'):""}
           </Typography>
        </TableCell>
        <TableCell align="left">
          <Typography style={{color:"#000000", fontSize: 16}} >
            {row.rel_trans_tradename}
          </Typography>
        </TableCell>
        <TableCell align="left">
          <Typography style={{color:"#000000", fontSize: 16}} >
            {t(row.vehiclestore_licenseplate)}
          </Typography>
        </TableCell> 
      </TableRow>
    );
  }));
  
  return(
    <>
      <Box sx={{ width: '100%' }}> 
        <EnhancedTableToolbar textHead={t(titleTable)} textReg={t('Text_Num_Reg')} numTotRegFilter={numTotRegFilter} numTotRegFormDI={numTotRegFormDI} textOf={t('Text_Of')}/>
          <TableContainer component={Paper} className="formdi-table-container" >
            <Table sx={{ minWidth: '100%' }} stickyHeader size="small"  aria-labelledby="tableTitle"> 
               <EnhancedTableHead order={order} orderBy={orderBy} onRequestSort={handleRequestSort} t={t}  i18n={i18n}/>
              <TableBody>    
                {listItems}
                {emptyRows > 0 && (
                <TableRow style={{ height: 33  * emptyRows}}>
                  <TableCell colSpan={8} />
                </TableRow>
                )}
              </TableBody>
              <TableFooter>
                <TableRow>
                {activeOffsetFormDI && (
                    <TableCell colSpan={2}>
                      <Box sx={{ flexShrink: 0, p: 1}}>
                        <div className="form-group">
                          <TextField
                            id="currencyOffsetFormDI"
                            name="currencyOffsetFormDI"
                            value={currencyOffsetFormDI}
                            inputProps={{ style: {maxLength: 100, color:"#4e73df",fontSize:14}}}
                            placeholder={t('Text_Range_Offset')}
                            variant="standard"
                            onChange={handleChangeOffset}
                            helperText={t('Text_Range_Offset')}
                            select
                            SelectProps={{
                              native: true,
                              value: currencyOffsetFormDI
                            }}>
                            {rangeOffsetFormDI.map((option) => (
                              <option key={option.value} value={option.value}>
                                {option.label}
                              </option>
                          ))}
                          </TextField>
                        </div>
                      </Box>  
                    </TableCell>
                  )}
                  <TablePagination
                    rowsPerPageOptions={[5, 10, 25]}
                    colSpan={8}
                    count={countData}
                    rowsPerPage={rowsPerPage}
                    page={countData===0?0:page}
                    labelRowsPerPage={t('Text_Rows_Per_Page')}
                    slotProps={{
                      inputProps: {
                        'aria-label': t('Text_Rows_Per_Page'),
                      },
                      native: true,
                    }}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                    ActionsComponent={TablePaginationActions}
                  />
                </TableRow>
              </TableFooter>
            </Table>
          </TableContainer>
      </Box>
    </>
  )
}

TableSortingShippingFormDI.propTypes = {
  dataFormDI: PropTypes.array.isRequired, 
  numTotRegFilter: PropTypes.number.isRequired,
  titleTable : PropTypes.string.isRequired, 
  activeOffsetFormDI: PropTypes.bool.isRequired,
  rangeOffsetFormDI: PropTypes.array.isRequired,
  currencyOffsetFormDI: PropTypes.number.isRequired,
  setCurrencyOffsetFormDI: PropTypes.func.isRequired,
  handleCloseDataEditFormDI: PropTypes.func.isRequired,
  setFormShipping: PropTypes.func.isRequired
};
  
export default TableSortingShippingFormDI;
